import { useMutation } from '@tanstack/react-query';
import { formatDate } from '@/utils/date';
import { showApiErrorToast } from '@/utils/errors';

/** Downloads a batch's Excel; `download` takes today's date for the file name. */
export function useDownloadPcmpBatchXlsx(download: (date: string) => Promise<void>) {
  return useMutation({
    mutationFn: () => download(formatDate(new Date())),
    onError: (error) => showApiErrorToast(error, 'Could not download the Excel file'),
  });
}
